/* --------------------------------------------------------------------------------------
   user.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class userService {
  /*@ngInject*/
  constructor(persistService, dataService) {
    this.persistService = persistService
    this.dataService = dataService
  }

  updateUserInvalidRetry(user) {
    if (user.attempts == undefined) {
      user.attempts = 0
    }

    var dtLess30 = new Date(Date.now())
    dtLess30.setMinutes(dtLess30.getMinutes() - 1); //last time within 15 mins?
    var dtLastAttempt = new Date(user.lastattempt);

    if (user.lastattempt == undefined) {
      user.lastattempt = new Date(Date.now())
    }

    if (dtLastAttempt < dtLess30) {
      user.attempts = 0
    }

    user.attempts = user.attempts + 1
    user.lastattempt = new Date().getTime();

    let users = this.getUsers().filter(usr => { return usr.user64 != user.user64 })
    users.push(user)
    this.persistService.setObject('users', users)
    return user
  }
  resetUser(user) {
    user.attempts = 0
    user.lastattempt = new Date().getTime()

    let users = this.getUsers().filter(usr => { return usr.user64 != user.user64 })
    users.push(user)
    this.persistService.setObject('users', users)
    return user
  }
  setUser(user) {
    let users = this.getUsers()
    if (users.find((usr) => { return usr.user64 == user.user64 }))
      return Promise.reject("Already exists")

    users.push(user)
    this.persistService.setObject('users', users)
    return Promise.resolve()
  }
  deleteUser(user) {
    let users = this.getUsers().filter(usr => { return usr.user64 != user.user64 })
    this.persistService.setObject('users', users)
  }
  getUsers() {
    var result = this.persistService.getObject('users')

    if (!result)
      result = []

    return result
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/user.service.js